import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Query } from 'react-apollo';
import Typography from '@material-ui/core/Typography';
import { useMutation } from '@apollo/react-hooks';
import { useSnackbar } from 'notistack';

import { getSearchResults } from '../../apollo/queries';
import { updateUserRole as updateUserRoleMutation } from '../../apollo/mutations';

import { replaceWidthAndHeight } from '../../utils/helper';
import ChangeUserSearch from './ChangeUserRoleSearch';
import CustomButton from '../../components/Button/CustomButton';

const conf = require('../../conf');

const ChangeUserContainer = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [search, setSearch] = useState('');
  const [changeUserDisabled, setChangeUserDisabled] = useState(true);
  const [chosenUser, setChosenUser] = useState('');

  const variables = { filter: { q: search }, pagination: { page: 1, perPage: 5 } };

  const makeAlert = (msg, type) => {
    enqueueSnackbar(msg, { variant: type });
  };

  const [updateUserRole] = useMutation(updateUserRoleMutation, {
    onCompleted: (data) => {
      const msg = data.updateUserRole ? t('add_user_role_success') : t('add_user_role_fail');

      if (data.updateUserRole) {
        makeAlert(msg, 'success');
      } else {
        makeAlert(msg, 'error');
      }
    },
    onError: (data) => {
      makeAlert(data.message, 'error');
    },
  });

  const submitForm = () => {
    if (!chosenUser || !chosenUser._id) {
      makeAlert(t('chosen_user_error'), 'error');
    }

    updateUserRole({
      variables: {
        userId: chosenUser._id,
        role: 'illustrator'
      },
    });
  };

  return (
    <Query query={getSearchResults} variables={variables}>
      {({ data, error, loading }) => {
        let results;

        if (data && data.getSearchResults && search && search.length > 0) {
          const { getSearchResults } = data;
          const { viewers } = getSearchResults;

          viewers.forEach(function (element) {
            element.type = t('search_viewer');
            element.link = '/profile/' + element.login;
          });

          results = [...viewers];
        }

        return (
          <div>
            <Typography variant="h3" style={{ marginBottom: 30 }}>
              {t('give_user_illustrator_heading')}
            </Typography>
            <ChangeUserSearch
              loading={loading}
              results={(results) && results}
              search={search}
              setChangeUserDisabled={setChangeUserDisabled}
              setChosenUser={setChosenUser}
              setSearch={setSearch} />
            <Typography
              variant="h6"
              style={{ margin: '20px 0px', width: '400px', color: '#CE1537' }}
            >
              {t('give_user_illustrator_description')}
            </Typography>
            <CustomButton
              style={{ margin: '20px 0px 20px' }}
              status="secondary"
              onClick={submitForm}
              disabled={changeUserDisabled}
            >
              {t('give_user_illustrator_role')}
            </CustomButton>
          </div>
        );
      }}
    </Query>
  );
};

export default ChangeUserContainer;